export default __webpack_public_path__ + "static/media/cover_big.bfdd683e.jpg";